import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Button, Textarea } from "expano-components";
import { Modal } from "components";
import getProductGroupSummaryMd from "utils/getProductGroupSummaryMd";

const SummaryMdModal = ({ product_group, handleClose }) => {
  const data = getProductGroupSummaryMd(product_group);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(data);
      toastr.success("Sukces", "Skopiowano do schowka");
    } catch (e) {
      console.error("Błąd kopiowania do schowka", e);
    }
  };

  return (
    <Modal
      header={{ title: "Podsumowanie produktu grupowego" }}
      size="lg"
      handleClose={handleClose}
      footer={<Button type="cancel" onClick={handleClose} />}
    >
      <Textarea
        meta={{}}
        input={{ value: data, readOnly: true }}
        minHeight={400}
      />
      <Button onClick={handleCopy} text="Kopiuj do schowka" />
    </Modal>
  );
};

export default connect(({ product_group }) => ({
  product_group: product_group.data,
}))(SummaryMdModal);
